import type { ApiQuery, ApiBody } from '../../../shared/api/contracts'
import { apiRequest } from './transport'

export async function fetchFinancialAnalysisSettings(signal?: AbortSignal) {
  return apiRequest<'GET /admin/financial-analysis/settings'>('/admin/financial-analysis/settings', { signal })
}
export async function updateFinancialAnalysisSettings(body: ApiBody<'PUT /admin/financial-analysis/settings'>, signal?: AbortSignal) {
  return apiRequest<'PUT /admin/financial-analysis/settings'>('/admin/financial-analysis/settings', { method: 'PUT', body, signal })
}
export async function previewFinancialAnalysis(params: ApiQuery<'GET /admin/financial-analysis/preview'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/financial-analysis/preview'>(`/admin/financial-analysis/preview?${new URLSearchParams(params)}`, { signal })
}
export async function startFinancialAnalysis(body: ApiBody<'POST /admin/financial-analysis/jobs'>, signal?: AbortSignal) {
  return apiRequest<'POST /admin/financial-analysis/jobs'>('/admin/financial-analysis/jobs', { method: 'POST', body, signal })
}
export async function fetchFinancialAnalysisJob(id: string, signal?: AbortSignal) {
  return apiRequest<'GET /admin/financial-analysis/jobs/:id'>(`/admin/financial-analysis/jobs/${encodeURIComponent(id)}`, { signal })
}
export async function fetchFinancialAnalysisJobs(params: ApiQuery<'GET /admin/financial-analysis/jobs'> = {}, signal?: AbortSignal) {
  const query = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) if (value != null) query.set(key, String(value))
  return apiRequest<'GET /admin/financial-analysis/jobs'>(`/admin/financial-analysis/jobs?${query}`, { signal })
}
export async function cancelFinancialAnalysisJob(id: string, signal?: AbortSignal) {
  return apiRequest<'POST /admin/financial-analysis/jobs/:id/cancel'>(`/admin/financial-analysis/jobs/${encodeURIComponent(id)}/cancel`, { method: 'POST', signal })
}
export async function deleteFinancialAnalysisJob(id: string, signal?: AbortSignal) {
  return apiRequest<'DELETE /admin/financial-analysis/jobs/:id'>(`/admin/financial-analysis/jobs/${encodeURIComponent(id)}`, { method: 'DELETE', signal })
}

export async function fetchFinancialAnalysisContext(params: ApiQuery<'GET /admin/financial-analysis/context'>, signal?: AbortSignal) {
  const query = new URLSearchParams(params)
  return apiRequest<'GET /admin/financial-analysis/context'>(`/admin/financial-analysis/context?${query}`, { signal })
}

export async function checkFinancialAnalysisScenarios(body: ApiBody<'POST /admin/financial-analysis/scenarios/check'>, signal?: AbortSignal) {
  return apiRequest<'POST /admin/financial-analysis/scenarios/check'>('/admin/financial-analysis/scenarios/check', { method: 'POST', body, signal })
}
